module.exports = __webpack_public_path__ + "img/47.71bc28d2.gif";